// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__p_55m","title":"InfoRow_title__38MJ6"};